<template>
  <!-- 运营工作台 -->
  <div class="operating-work-bench">
    <div class="work-bench-left">
      <div class="work-bench-left-top">
        <div class="filter-area">
          <Select v-model="selectValue">
            <Option v-for="(item,index) in option" :key="index" :value="item.value">{{item.label}}</Option>
          </Select>
        </div>
        <sale-list :saleListConfig="saleListConfig"></sale-list>
      </div>
      <div class="work-bench-left-bottom">
        <div class="table-wrap">
          <div class="table-item" v-for="(value,key) in tableData" :key="key">
            <stor-table :sortTableConfig="value"></stor-table>
          </div>
        </div>
        <div class="table-wrap">
          <div class="table-item" v-for="(normalitem,key) in normalTableData" :key="key">
            <normal-table :normalTableconfig="normalitem"></normal-table>
          </div>
        </div>
      </div>
    </div>
    <div class="commodity-work-bench-right">
      <div class="work-bench-right-top">
        <info-list :info="saleInfo"></info-list>
      </div>
      <div class="work-bench-right-bottom">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>
  </div>
</template>
<script>
import normalTable from "commonCrumb/workBench/normalTable.vue";
import storTable from "commonCrumb/workBench/storTable.vue";
import infoList from "commonCrumb/workBench/infoList.vue";
import saleList from "commonCrumb/workBench/saleList.vue";

export default {
  components: {
    storTable,
    infoList,
    saleList,
    normalTable
  },
  data() {
    return {
      selectValue: 5,
      option: [
        {
          label: "所有",
          value: 1
        },
        {
          label: "乔丹官方旗舰店",
          value: 2
        },
        {
          label: "百尚天猫店",
          value: 3
        },
        {
          label: "乔丹儿童专卖店",
          value: 4
        },
        {
          label: "百尚、乔丹、儿童",
          value: 5
        }
      ],
      saleListConfig: [
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 45856,
              label: "昨日销售总额"
            },
            {
              value: 65654,
              label: "今日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 56589,
              label: "昨日订单总量"
            },
            {
              value: 78452,
              label: "今日订单总量"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 78459,
              label: "昨日增会员总数"
            },
            {
              value: 78451,
              label: "今日增会员总数"
            }
          ]
        }
      ],
      tableData: [
        {
          ranking: true,
          product: true,
          columns: [
            {
              title: "销售金额",
              key: "xsje"
            }
          ],
          data: [
            {
              commodity: {
                text: "乔丹",
                src: require("commonImages/workBench/1.png")
              },
              xsje: 785
            },
            {
              xsje: 654
            },
            {
              xsje: 451
            }
          ],
          //dashedColor: "red", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近七日畅销商品 金额TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: true,
          columns: [
            {
              title: "销售数量",
              key: "xsje"
            }
          ],
          data: [
            {
              commodity: {
                text: "乔丹",
                src: require("commonImages/workBench/1.png")
              },
              xsje: 985
            },
            {
              xsje: 784
            },
            {
              xsje: 565
            }
          ],
          dashedColor: "green", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日畅销商品 数量TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: false,
          columns: [
            {
              title: "商品链接",
              key: "splj"
            },
            {
              title: "成交数量",
              key: "cjsl"
            }
          ],
          data: [
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "3214"
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "3214"
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "3214"
            }
          ],
          dashedColor: "blue", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日畅销商品链接 TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        }
      ],
      saleInfo: {
        icon: "md-appstore",
        size: "30",
        color: "",
        custom: "",
        title: "促销活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      publicInfo: {
        icon: "ios-megaphone",
        size: "30",
        color: "",
        custom: "",
        title: "公告活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      normalTableData: [
        {
          title: "近三日商品销售金额TOP榜", //表标题
          orange: true, //表头颜色
          blue: false,
          green: false,
          columns: [
            {
              title: "排行",
              key: "ph"
            },
            {
              title: "商品名称",
              key: "spmc"
            },
            {
              title: "货号",
              key: "hh"
            },
            {
              title: "销售总金额",
              key: "xszje"
            }
          ],
          data: [
            {
              ph: 1,
              spmc: "乔丹男鞋",
              hh: "c20332",
              xszje: "322232"
            },
            {
              ph: 2,
              spmc: "百尚女鞋",
              hh: "23f34ff",
              xszje: "34566"
            }
          ]
        },
        {
          title: "近三日商品销售金额TOP榜", //表标题
          orange: false, //表头颜色
          blue: true,
          green: false,
          columns: [
            {
              title: "排行",
              key: "ph"
            },
            {
              title: "商品名称",
              key: "spmc"
            },
            {
              title: "货号",
              key: "hh"
            },
            {
              title: "销售数量",
              key: "xssl"
            }
          ],
          data: [
            {
              ph: 1,
              spmc: "乔丹男鞋",
              hh: "c20332",
              xssl: "322"
            },
            {
              ph: 2,
              spmc: "百尚女鞋",
              hh: "23f34ff",
              xssl: "345"
            }
          ]
        },
        {
          title: "近三日商品销售金额TOP榜", //表标题
          orange: false, //表头颜色
          blue: false,
          green: true,
          columns: [
            {
              title: "排行",
              key: "ph"
            },
            {
              title: "会员昵称",
              key: "hync"
            },
            {
              title: "购买金额",
              key: "gmje"
            },
            {
              title: "购买数量",
              key: "gmsl"
            }
          ],
          data: [
            {
              ph: 1,
              hync: "乔丹男鞋",
              gmje: "c20332",
              gmsl: "322232"
            },
            {
              ph: 2,
              hync: "百尚女鞋",
              gmje: "23f34ff",
              gmsl: "34566"
            }
          ]
        }
      ]
    };
  }
};
</script>
<style lang="less">
.operating-work-bench {
  padding: 8px 12px;
  display: flex;
  display: -webkit-flex;
  .work-bench-left {
    width: 80%;
    .filter-area {
      margin-bottom: 20px;
      text-align: right;
      .ark-select {
        width: 200px;
      }
    }
    .ark-col-span-8 {
      box-sizing: border-box;
    }

    .work-bench-left-bottom {
      margin-top: 20px;
      .table-wrap {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        margin-bottom: 15px;
        .table-item {
          margin-right: 12px;
          flex: 1;
          .sortTable {
            table {
              width: 100%;
            }
          }
          &:last-child {
            margin-right: 0;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .commodity-work-bench-right {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    width: 20%;
    .work-bench-right-top {
      flex: 2;
    }
    .work-bench-right-bottom {
      flex: 3;
    }
  }
}
</style>


